// extracted by mini-css-extract-plugin
export default {"wrapper":"Oydi8belc7izNo1KvLWf","borderless":"XH1l27sSawY4glNpu_8y","childrenWrapper":"cHqy1UvhhGITldDbVyWy"};